import type { ReactNode } from 'react';
import { Icon } from './Icon';
import type { IconName } from './icons';

/**
 * Nothing to show inside a card: a small icon, one muted line and an optional small action, about one row tall, so
 * an empty card is as calm as a full one. Full-page empty states keep EmptyState (with its illustration).
 */
export function InlineEmpty({ icon = 'info', children, action }: { icon?: IconName; children: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty-inline">
      <Icon name={icon} size={24} />
      <span className="empty-inline-text">{children}</span>
      {action && <span className="empty-inline-action">{action}</span>}
    </div>
  );
}
